/// <amd-module name="Tfs/Frame/Components/Market/Market" />
import * as React from "react";
import * as Resources from "Tfs/Frame/Resources";
import { VssComponent } from "VSS/Platform/Layout";
import { ScreenSize } from "VSS/Core/Util/Screen";
import { ExpandableContainer, IExpandable } from "VSSUI/Expandable";
import { Icon, IconSize } from "VSSUI/Icon";
import { ContextualMenu } from "VSSUI/Menu";
import { Location } from "VSSUI/Utilities/Position";
import { ScreenSizeConditional } from "VSSUI/Utilities/ScreenSize";
import { Button } from "VSSUI/Button";
import { getMenuItems } from "VSS/Features/PlatformUI/ContributedMenu";

export class Market extends VssComponent<{}> {
    public render(): JSX.Element {
        return (
            <ScreenSizeConditional condition={screenSize => screenSize > ScreenSize.xsmall}>
                <ExpandableContainer
                    excludeFocusZone={true}
                    expandableId="market-menu"
                    renderCallout={this.renderCallout}
                    role="menuitem"
                >
                    <Button
                        ariaLabel={Resources.Marketplace}
                        iconProps={{ size: IconSize.medium, iconName:"Shop" }}
                        subtle={true}
                        tooltipProps={{ text: Resources.Marketplace }}
                    />
                </ExpandableContainer>
            </ScreenSizeConditional>
        );
    }

    private renderCallout = (dropdown: IExpandable, id: string, element: HTMLElement): JSX.Element => {
        return (
            <ContextualMenu
                onDismiss={dropdown.collapse}
                anchorElement={element}
                anchorOrigin={{ horizontal: Location.end, vertical: Location.end }}
                menuProps={{
                    id,
                    items: getMenuItems(this.context.pageContext, "ms.vss-tfs-web.market-menu")
                }}
                menuOrigin={{ horizontal: Location.end, vertical: Location.start }}
            />
        );
    };
}

VssComponent.register("ms.vss-tfs-web.market", Market);
